module.exports = __webpack_public_path__ + "static/media/img-hhr-logo.f020abc4.png";